import StarRatings from "component/design-system/StarRatings";
import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import VerticalSeparator from "component/product/vertical-separator/VerticalSeparator";
import HideIf from "util/HideIf";
import styles from "./product-rating-mobile.module.scss";

function ProductRatingMobile(props: any) {
  const { product, showSeparator = false } = props;
  const averageRating = product?.averageRating || 0;
  const totalReviewsCount = product?.totalReviewsCount || 0;

  if (!totalReviewsCount) {
    return null;
  }

  return (
    <div className={styles.container}>
      <HideIf show={showSeparator}>
        <VerticalSeparator className={`${styles.vertical_separator}`} />
      </HideIf>
      <div className={styles.rating_container}>
        <StarRatings rating={averageRating} filled />
      </div>
      <PAText color="grey" fontSize={FONT_SIZE[0]} className="m-l-5">
        (
        {totalReviewsCount}
        )
      </PAText>
    </div>
  );
}

export default ProductRatingMobile;
